import { PropsWithChildren, useContext } from 'react';
import styles from './Timeline.module.scss';
import { Context } from './context';

export const Info = (props: PropsWithChildren<any>) => {
	const { children, isLast } = props;
	const { dir } = useContext(Context);
	return <div className={`${dir === 'vertical' ? styles.infoContainerVert : styles.infoContainerHorz}
		${dir === 'vertical' && isLast && styles.infoContainerVertLast}
	`}>
		{children}
	</div>
}
